import React from 'react';
import { Image } from '@westhechiang/image';
import { icons } from './icons';

export const Icon = ({ icon, ...props }) => {
  return <Image height="48px" width="48px" src={icons[icon]} {...props} />;
};

export default Icon;
